export default __webpack_public_path__ + "static/media/bee1.e4ce9992.jpg";